export const APP_NAME = "RR Vilas";
